import requestUtils from 'api/requestUtils'
import type { actions } from '@luxuryescapes/contract-svc-lux-loyalty'

type Payload = actions['checkRewardsAvailability']['requestBody']['content']['application/json']
type AvailabilityResponse = actions['checkRewardsAvailability']['responses']['200']['content']['application/json']

export type ClassicRewardAvailabilityItem = Payload['items'][number]
export type ClassicRewardAvailabilityResult = AvailabilityResponse['result'][number]

export async function requestClassicRewardAvailability(
  customerId: string,
  currency: string,
  items: Array<ClassicRewardAvailabilityItem>,
): Promise<Array<ClassicRewardAvailabilityResult>> {
  const response = await requestUtils.post<AvailabilityResponse, Payload>(
    '/api/lux-loyalty/rewards/availability',
    { customerId, currency, items },
    { credentials: 'include' },
  )
  return response.result ?? []
}
